






import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class CardIcon extends Vue {
  @Prop({ required: true })
  value!: string;
}
